import { belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import type BloodPressureSessionStartedJournalEvent from "parog-web/models/blood-pressure-session-started-journal-event";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class BloodPressureSessionRequestedJournalEvent extends JournalEvent {
  static override type = "blood-pressure-session-requested-journal-event";

  @belongsTo("blood-pressure-session-started-journal-event", {
    async: false,
    inverse: "bloodPressureSessionRequestedJournalEvent"
  })
  declare bloodPressureSessionStartedJournalEvent: BloodPressureSessionStartedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.blood-pressure-session-requested-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  /**
   * Return if the request is opened or not.
   * Not the session itself. It means if a session is started, the request is closed.
   */
  get isOpened(): boolean {
    return this.bloodPressureSessionStartedJournalEvent == null;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "blood-pressure-session-requested-journal-event": BloodPressureSessionRequestedJournalEvent;
  }
}
